import styled, { css } from 'styled-components';
import Icon from 'components/Icon';

const TEMP_COLOR_USER_MESSAGE_BG = '#DAEBFF'; // TODO: Replace with design token
const TEMP_COLOR_AI_ICON_BG = '#0064FE'; // TODO: Replace with design token

export const UserMessageStyles = css`
    background-color: ${TEMP_COLOR_USER_MESSAGE_BG};
    border-radius: ${({ theme }) => theme.RadiusMedium};
    max-width: ${({ theme }) => `calc(100% - ${theme.Spacing16})`};
    width: fit-content;
    padding: ${({ theme }) => theme.Spacing16};
    margin-left: auto;
`;

export const AIIcon = styled(Icon)`
    background-color: ${TEMP_COLOR_AI_ICON_BG};
    border-radius: 50%;
    padding: ${({ theme }) => theme.Spacing4};
    display: block;
`;
